import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {LoggerService} from '@app/core/services/logger.service'
import {Data, ElasticQuery} from '@app/core/services/rest-api.model'

export {Data}

@Injectable()
export class DataService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getData(request: ElasticQuery): Observable<Data> {
    const url = 'api://Data'
    this.logger.log(request.toJson())
    return this.http.post<Data>(url, request.toJson()).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }
}
